/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon16Light = forwardRef('ArrowADownLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.707 12H10.5a.5.5 0 0 1 0 1h-6A1.5 1.5 0 0 1 3 11.5v-6a.5.5 0 0 1 1 0v5.793l8.146-8.147a.5.5 0 0 1 .708.708L4.707 12Z" })));
});
